import React from 'react';
import {GlassCard} from "../ui/Card";

const InfoSection: React.FC = () => {
    return (
        <section className="section info-section-centered">
            <div className="container">
                <div className="info-grid">
                <GlassCard>
                    <h2 className="section-title">Если это <strong>про вас</strong></h2>
                    <ul className="list tech-list">
                        <li>Есть идея, но нет технического партнёра</li>
                        <li>Уже общались с разработчиками — стало только сложнее</li>
                        <li>Не хотите переплачивать за лишние функции</li>
                        <li>Важно понимать сроки, бюджет и результат</li>
                    </ul>
                </GlassCard>

                <GlassCard>
                    <h2 className="section-title">Как я <strong>помогаю</strong></h2>
                    <ul className="list tech-list">
                        <li>Формулирую вместе с вами минимальную версию продукта (MVP)</li>
                        <li>Проектирую архитектуру, которая не ломается через год</li>
                        <li>Настраиваю прозрачный процесс разработки</li>
                        <li>Запускаю продукт и помогаю с развитием</li>
                    </ul>
                </GlassCard>
                </div>
            </div>
        </section>
    );
};

export default InfoSection;
